import { COMMENT_ACTION } from './sharedActions/comment';
import { COMPARE_ACTION } from './sharedActions/compare';
import { DELETE_ACTION } from './sharedActions/delete';
import { EDIT_ACTION } from './sharedActions/edit';
import { MANAGE_ACCESS_ACTION } from './sharedActions/manageAccess';
let DEFAULT_ACTIONS;

// This is necessary to break a cyclic dependency
// https://mermaid.live/edit#pako:eNpVkTFvwjAQhf9KdHNI7GBMyIBEywpLO7XuYMUHpEpsFF9UKOK_1yEJUje_u_v8nn03KJ1BKOBQu5_ypFuK3l-U3S8_v31auubsLFryaeOMrn26xRoJd71IyF---sloNltHe75UNijOBtB60j1n8KC7mjYlVaE2MZxFs-RBiYES_ykfgqAZoXBHb_pkxWA4-o1BLeGF0o33OHm9DrUnNuVkykIMDbaNrkx4-E3ZKFJAJ2xQQRGOY2YFyt7DqO7IvV1tCQW1HcbQnY0m3Fb62OpmKrauO56gOIRPCuqs7Ydzz2aQUNzgAkXOE5nnc8lYzld8vshiuELBM5YsuFgJJnMmJOPiHsPv4wKWSJGxuZQ8tLKML2QMaCpy7W7Y22N99z-sH5QI
export const getDefaultActions = () => {
  if (!DEFAULT_ACTIONS) {
    DEFAULT_ACTIONS = [EDIT_ACTION, MANAGE_ACCESS_ACTION, COMMENT_ACTION, COMPARE_ACTION, DELETE_ACTION];
  }
  return DEFAULT_ACTIONS;
};